import { PhoneOutgoing } from 'lucide-react';

import { useCallDetail } from '@/context/CallProvider';

import { useCallTranscriptsQuery } from '@/query/call.query';

import { DATE_FORMAT, formatDate } from '@/lib/date';

export const CallTranscript = () => {
  const { call: callDetail } = useCallDetail();

  const { data: messages, isLoading } = useCallTranscriptsQuery(callDetail?.id, {
    enabled: !!callDetail?.id,
  });

  if (!callDetail.transcriptUrl) {
    return <div className="text-sm text-muted-foreground">No transcript available.</div>;
  }

  const lastMessage = messages && messages.length > 0 ? messages[messages.length - 1] : null;

  let endTime = '';

  if (lastMessage) {
    endTime = formatDate(lastMessage.timestamp, DATE_FORMAT.TIME_ONLY);
  }

  const renderMessages = () => {
    return messages?.map(m => {
      const isAssistant = m.role === 'assistant';
      const timestamp = formatDate(m.timestamp, DATE_FORMAT.TIME_ONLY);

      return (
        <div className={'mb-3 cursor-pointer transition-colors '} key={m.timestamp}>
          <div className="relative group">
            <div className="cursor-default">
              <div className="transition-opacity" data-state={isAssistant ? 'closed' : 'open'}>
                <div className={`flex ${isAssistant ? 'justify-start' : 'justify-end'}`}>
                  <div
                    className={
                      'relative max-w-[80%] rounded-2xl px-4 py-2 cursor-pointer ' +
                      (isAssistant
                        ? 'rounded-bl-xs backdrop-blur-sm bg-black/5 text-gray-900 dark:bg-white/5 dark:text-gray-100'
                        : 'rounded-br-xs bg-primary text-primary-foreground')
                    }
                  >
                    <div
                      className={
                        'mb-1 flex items-center gap-2 text-xs font-medium ' +
                        (isAssistant ? 'text-primary' : 'text-primary-foreground/90')
                      }
                    >
                      <span>{isAssistant ? 'Assistant' : 'User'}</span>
                      <span className="opacity-0 group-hover:opacity-100 transition-opacity text-xs text-muted-foreground">
                        {timestamp}
                      </span>
                    </div>
                    <div
                      className={
                        isAssistant ? 'text-sm text-gray-800 dark:text-gray-200' : 'text-sm'
                      }
                    >
                      {m.content}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="relative flex-1 h-full min-h-0">
      <div className="absolute left-0 right-0 bottom-0 h-8 pointer-events-none bg-gradient-to-b from-transparent to-white dark:to-zinc-900 z-10" />
      <div className="flex-1 h-full min-h-0 overflow-y-scroll px-4 pb-16 pt-4">
        {isLoading ? (
          <div> Loading transcript...</div>
        ) : (
          <>
            {renderMessages()}

            {/* Call end marker */}
            <div className="mb-3 mt-4 flex justify-center">
              <div className="flex items-center justify-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 shadow-xs dark:border-gray-800 dark:bg-gray-900/20 max-w-[75%]">
                <PhoneOutgoing className="text-red-500 h-4 w-4" />
                <div className="text-xs font-medium text-gray-700 dark:text-gray-300">
                  Call ended {endTime}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
